import latinize from 'latinize';

export default {
    latinize,
    urlfy(string) {
        return this.charsAndDigits(this.latinize(string), '-')
            .toLowerCase()
            .replace(/-+/g, '-');
    },
    charsAndDigits(string = '', replacement = ' ') {
        return string.replace(/[^\d\w]/g, replacement);
    },
};



// WEBPACK FOOTER //
// ./src/utils/latinize.js